import * as S from './styles'

export const SpinnerPage = () => (
  <S.Wrapper>
    <S.BigSpinner></S.BigSpinner>
  </S.Wrapper>
)
